import {gql} from "apollo-angular";
import {catalogPayableItemFields} from "../catalog-payable-scheme/catalog-payable-scheme.graphql";
import {baseResponse, baseResponseGraphqlField} from "../../../base.graphql";



export const catalogBaseSchemeFields = `
id
catalogyUniqueId
catalogyDescriptions
billingCatalogyItems {
  ${catalogPayableItemFields}
}
`


export const CREATE_CATALOG_BASE_SCHEME = gql`
  mutation CreateCatalogyBaseScheme($input: CatalogySchemeInputObjects!) {
    createCatalogyBaseScheme(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${catalogBaseSchemeFields}
      }
    }
  }
`


export const UPDATE_CATALOG_BASE_SCHEME = gql`
  mutation UpdateCatalogyBaseScheme($input: CatalogySchemeInputObjects!) {
    updateCatalogyBaseScheme(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${catalogBaseSchemeFields}
      }
    }
  }
`


export const GET_CATALOG_BASE_SCHEME = gql`
  query GetInstitutionServiceCatalogSchemes($billingUniqueId: String) {
    getInstitutionServiceCatalogSchemes(billingUniqueId: $billingUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${catalogBaseSchemeFields}
      }
    }
  }
`

export const CITIZEN_GET_INSTITUTION_SERVICE_CATALOG_SCHEMES = gql`
  query CitizenGetInstitutionServiceCatalogSchemes($billingUniqueId: String) {
    citizenGetInstitutionServiceCatalogSchemes(billingUniqueId: $billingUniqueId) {
      response {
        ${baseResponse}
      }
      data {
        ${catalogBaseSchemeFields}
      }
    }
  }
`

export const DELETE_SERVICE_CATALOG_SCHEMES = gql`
  mutation DeleteCatalogyBaseScheme($uniqueId: String) {
    deleteCatalogyBaseScheme(uniqueId: $uniqueId) {
      response {
        ${baseResponse}
      }
    }
  }
`
